module.exports = __webpack_public_path__ + "static/img/5.b76b747.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/5.png
// module id = +NMI
// module chunks = 0